import React from 'react';

import { Box, Heading, ButtonPrimary, Text } from '@primer/components'
import { Link } from "react-router-dom";
import LazyLoad from 'react-lazyload';

import { useProduct } from '../hooks/useProduct'
import RepositorySearch from './RepositorySearch'


export default function (props) {
  const productDetails = useProduct()

  return (
    <Box className="container-lg pb-md-8 pl-4 pr-4 pt-4 pl-md-0 pr-md-0 pt-md-6 pb-4">
      <Heading as="h3" className="mb-0">Audit and fix technical debt on demand</Heading>
      <Text as="p" className="f3">Review your entire codebase at any time securely in your browser in a matter of seconds with nothing to install. Fix at your own pace or let {productDetails.name} fix it for you.</Text>
      <LazyLoad height="1012px">
        <div className="mt-8 position-relative">
          <Link to="/higher-tier/django-doctor-example">
            <img src="/mockup-audit-laptop-isolated.png" width="100%" alt="" />
          </Link>
        </div>
      </LazyLoad>
      <div className="d-md-flex mt-8 pb-0 f3 mb-0">
        <ul className="col-md-6 bullet-list-blue ml-4 mr-4 ml-md-0 mr-md-0">
            <li className="mb-3">Find vulnerabilities and maintainability problems</li>
            <li className="mb-3">Get remediation advice</li>
        </ul>
        <ul className="col-md-6 bullet-list-blue ml-4 mr-4 ml-md-0 mr-md-0">
            <li className="mb-3">Improve team agility through better code quality</li>
            <li className="mb-3">Spend less time reviews code or fixing bugs</li>
        </ul>
      </div>
      <Box className="mb-4">
      <Heading as="h2" fontSize={3} className="mt-8 mb-4">View codebase audit now</Heading>
        <RepositorySearch exampleRepos={props.exampleRepos} />
      </Box>
      <Box className="position-relative pl-4 pr-4">
        <Text as="h3" className="text-center">
          <a href={`${productDetails.gitHubMarketplaceLink}#pricing-and-setup`} className="text-white">
            <ButtonPrimary variant="large" className="f3 p-3">
              Add to GitHub
            </ButtonPrimary>
          </a>
        </Text>
      </Box>

    </Box>
  )

}
